import { Outlet, createFileRoute } from "@tanstack/solid-router";
import Navbar from "~/components/navbar";
import { SiteFooter } from "~/components/site-footer";

export const Route = createFileRoute("/_main")({
  component: MainLayout,
});

function MainLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <SiteFooter />
    </>
  );
}
